'use client'

import { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { handleCMS } from "@/(front-desk)/store"
import { Pattern1, Pattern2, Pattern3 } from "@/(front-desk)/utils/patterns"
import { reportError } from "@/(front-desk)/utils/functions"
import { ArrowUpRightIcon } from "@heroicons/react/20/solid"
import { throttle } from "lodash"
import History from "@/(front-desk)/(pages)/about/(components)/History"
import Award from "@/(front-desk)/(pages)/about/(components)/Award"
import classNames from "classnames"
import axios from "axios"
import Link from "next/link"

export const TransportationLink = (props) => {
    const { language } = props
    return (
        <Link
            href="/information/transportation"
            className="w-full p-[2.5rem] bg-black-900 rounded-[1.25rem] transition-transform duration-300 hover:scale-105"
        >
            <svg className="w-[2.8rem] mb-[1.5rem]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 46" fill="none">
                <path className="fill-main" fillRule="evenodd" clipRule="evenodd" d="M42.5751 29.3001L45.6502 43.1751C45.8001 43.7751 45.5751 44.4501 45.1251 44.7501C44.8251 45.0501 44.3751 45.2001 44.0001 45.2001C43.8501 45.2001 43.6251 45.2001 43.4751 45.1251L33.5001 41.7501L23.5252 45.1251C23.2252 45.2751 22.8501 45.2751 22.4751 45.1251L12.5001 41.7501L2.60015 45.2001C2.00015 45.4251 1.40015 45.2751 0.95015 44.9001C0.50015 44.5251 0.27515 43.9251 0.35015 43.3251L2.45015 29.4501C2.60015 28.7001 3.12515 28.1001 3.87515 28.0251L12.8751 26.7501C10.0252 22.7001 7.70015 18.4251 7.70015 15.1251C7.70015 7.1751 14.3751 0.725098 22.5501 0.725098C30.7251 0.725098 37.4002 7.1751 37.4002 15.1251C37.4002 18.4251 35.0751 22.7001 32.2251 26.7501L41.1502 28.0251C41.9002 28.1001 42.4251 28.6251 42.5751 29.3001ZM34.0252 15.1251C34.0252 9.0501 28.9251 4.1001 22.5501 4.1001C16.1751 4.1001 11.0752 9.0501 11.0752 15.1251C11.0752 19.2501 17.0002 27.2001 22.5501 33.2001C28.1001 27.1251 34.0252 19.2501 34.0252 15.1251ZM32.9751 38.3751C33.2751 38.2251 33.6502 38.2251 34.0252 38.3751L41.7501 41.0001L39.5751 31.2501L29.8251 29.8251C28.1001 32.0001 26.3001 34.0251 24.8751 35.6001C24.2751 36.2751 23.3751 36.6501 22.4751 36.6501C21.5751 36.6501 20.6751 36.2751 20.0751 35.6001C18.6502 34.0251 16.8502 32.0001 15.1251 29.8251L5.60015 31.2501L4.10015 41.0751L11.9751 38.3751C12.2751 38.2251 12.6502 38.2251 13.0252 38.3751L23.0002 41.7501L32.9751 38.3751ZM22.5508 8.8252C26.3008 8.8252 29.3008 11.8252 29.3008 15.5752C29.3008 19.3252 26.3008 22.3252 22.5508 22.3252C18.8008 22.3252 15.8008 19.3252 15.8008 15.5752C15.8008 11.8252 18.8008 8.8252 22.5508 8.8252ZM22.5508 12.2002C20.6758 12.2002 19.1758 13.7002 19.1758 15.5752C19.1758 17.4502 20.6758 18.9502 22.5508 18.9502C24.4258 18.9502 25.9258 17.4502 25.9258 15.5752C25.9258 13.7002 24.4258 12.2002 22.5508 12.2002Z" />
            </svg>
            <div className="flex gap-3 text-[1.75rem] text-white font-semibold mb-[0.75rem]">
                {language === 'zh_hant' && '交通資訊'}
                {language === 'en' && 'TRANSPORTATION'}
                <ArrowUpRightIcon className="w-[2.5rem] h-[2.5rem]" />
            </div>
            <div className="text-black-500 font-light">
                {language === 'zh_hant' && '如何前往放視大賞展覽場地'}
                {language === 'en' && 'How to get to the exhibition venue'}
            </div>
        </Link>
    )
}
export const FacebookLink = (props) => {
    const { language } = props
    const CMS = useSelector((state) => state.CMS)
    return (
        <a  
            href={CMS?.registries['cms.home.footer.fb_link']}
            target="_blank"
            className="w-full p-[2.5rem] bg-black-900 rounded-[1.25rem] transition-transform duration-300 hover:scale-105"
            title="另開視窗前往放視大賞 FB 粉絲專頁"
        >
            <svg className="w-[2.8rem] mb-[1.5rem]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
                <path d="M35.5516 19.35H31.3516H29.8516V17.85V13.2V11.7H31.3516H34.5016C35.3266 11.7 36.0016 11.1 36.0016 10.2V2.25C36.0016 1.425 35.4016 0.75 34.5016 0.75H29.0266C23.1016 0.75 18.9766 4.95 18.9766 11.175V17.7V19.2H17.4766H12.3766C11.3266 19.2 10.3516 20.025 10.3516 21.225V26.625C10.3516 27.675 11.1766 28.65 12.3766 28.65H17.3266H18.8266V30.15V45.225C18.8266 46.275 19.6516 47.25 20.8516 47.25H27.9016C28.3516 47.25 28.7266 47.025 29.0266 46.725C29.3266 46.425 29.5516 45.9 29.5516 45.45V30.225V28.725H31.1266H34.5016C35.4766 28.725 36.2266 28.125 36.3766 27.225V27.15V27.075L37.4266 21.9C37.5016 21.375 37.4266 20.775 36.9766 20.175C36.8266 19.8 36.1516 19.425 35.5516 19.35Z" fill="#1877F2"/>
            </svg>
            <div className="flex gap-3 text-[1.75rem] text-white font-semibold mb-[0.75rem]">
                {language === 'zh_hant' && 'FB 粉絲專頁'}
                {language === 'en' && 'FACEBOOK'}
                <ArrowUpRightIcon className="w-[2.5rem] h-[2.5rem]" />
            </div>
            <div className="text-black-500 font-light">
                {language === 'zh_hant' && '追蹤獲得最新展覽、活動、競賽資訊'}
                {language === 'en' && 'Follow us for the latest updates on exhibitions, events, and competitions'}
            </div>
        </a>
    )

}
export default function about() {
    
    const dispatch = useDispatch()
    const CMS = useSelector((state) => state.CMS)
    const [ analyzeCount, setAnalyzeCount ] = useState(null)
    const [ exhibitionCount, setExhibitionCount ] = useState(0)
    const [ awardCount, setAwardCount ] = useState(0)
    const [ competeCount, setCompeteCount ] = useState(0)
    const [ visitCount, setVisitCount ] = useState(0)
    const [ scrollWatcher, setScrollWatcher ] = useState(false)
    const analyzeRef = useRef()
    const analyzeList = {
        'exhibitors': {
            name: CMS.registries['cms.home.about_me.n1.name'],
            count: exhibitionCount,
            func: setExhibitionCount,
            pattern: <Pattern1 className="w-full fill-main-700 stroke-main" />
        },
        // 'awards': {
        //     name: CMS.registries['cms.home.about_me.n2.name'],
        //     count: awardCount,
        //     func: setAwardCount,
        //     pattern: <Pattern2 className="w-full fill-main-700 stroke-main" />
        // },
        'entries': {
            name: CMS.registries['cms.home.about_me.n3.name'],
            count: competeCount,
            func: setCompeteCount,
            pattern: <Pattern2 className="w-full fill-main-700 stroke-main stroke-1" />
        },
        'visitors': {
            name: CMS.registries['cms.home.about_me.n4.name'],
            count: visitCount, // ???
            func: setVisitCount,
            // pattern: <img className="w-full" src={halfFlower.src} alt="" />
            pattern: <Pattern3 className="w-full fill-main-700 stroke-main stroke-1" />
        }
    }

    useEffect(() => {
        if (!CMS.about) {
            getAbout()
        }

        return(() => {
            window.removeEventListener('scroll', isScrolledIntoView, null)
        })
    }, [])

    useEffect(() => {
        if (CMS.registries) {
            setAnalyzeCount({
                'exhibitors': CMS.registries['cms.home.about_me.n1.number'],
                'awards': CMS.registries['cms.home.about_me.n2.number'],
                'entries': CMS.registries['cms.home.about_me.n3.number'],
                'visitors': CMS.registries['cms.home.about_me.n4.number'],
            })
        }
    }, [CMS.registries])

    useEffect(() => {
        if (analyzeRef.current && !scrollWatcher) {
            setScrollWatcher(true)
            window.addEventListener('scroll', throttle(isScrolledIntoView, 500))
        }
    }, [analyzeRef.current, scrollWatcher])

    function getAbout() {
        axios.get('/api/v1/cms/zh_hant/posts?category=cms.home.about_me.description')
        .then((res) => {
            // console.log('about success: ', res.data.body.results)
            dispatch(handleCMS.actions.setAbout(res.data.body.results[0]))
        })
        .catch((err) => {
            // console.log(err.config?.url, err)
            reportError(err, true)
        })
    }
    function isScrolledIntoView() {
        if (analyzeRef.current) {
            const rect = analyzeRef.current.getBoundingClientRect()
            const elemTop = rect.top
            const elemBottom = rect.bottom
            const isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight)
            // console.log(isVisible)
            if (!isVisible) {
                setExhibitionCount(0)
                setAwardCount(0)
                setCompeteCount(0)
                setVisitCount(0)
            }
        }
    }
    return (
        <>
        <title>關於放視 - 放視大賞</title>
        <main id="about">
            <div className="page-banner py-16">
                <div className="page-banner-content flex justify-between items-center">
                    <div>
                        <h1 className="title">About</h1>
                        <h2 className="sub-title">關於放視</h2>
                    </div>
                </div>
            </div>
            <div id="main" className="pb-10">
                <div className="overview mb-[5rem]">
                    <div className="w-full pt-[6rem] pb-[5rem]">
                        <div className="mb-[3.75rem]">
                            <h2 className="text-[1.875rem] text-white font-bold mb-3">{CMS.about && CMS.about.contents.subject}</h2>
                            <div className="text-white whitespace-pre-wrap">{CMS.about && CMS.about.contents.abstract}</div>
                        </div>
                        <div className="flex-center flex-wrap gap-y-[2.5rem]" ref={analyzeRef}>
                            { analyzeCount && Object.keys(analyzeList).map((name, index) => {
                                const info = analyzeList[name]
                                if (info.count < analyzeCount[name]) {
                                    setTimeout(() => {
                                        const range = Math.floor(analyzeCount[name] / 100)
                                        if (analyzeCount[name] - info.count > range) {
                                            info.func(info.count + range)
                                        }
                                        else {
                                            info.func(analyzeCount[name])
                                        }
                                    }, 20)
                                }
                                const item = 
                                    <div key={`analyze-${index}`} className="item px-0 w-full md:w-[33%]">
                                        <div className="pattern flex-center mb-4 w-[3rem] aspect-square">
                                            {info.pattern}
                                        </div>
                                        <div className={classNames('count text-[2.5rem] text-main font-bold font-zen-dots mb-2', {
                                        })}>{info.count}</div>
                                        <div className="text-white">{analyzeList[name].name}</div>
                                    </div>
                                return item
                            })}
                        </div>
                    </div>
                </div>
                <div className="mb-[10rem]">
                    <History />
                </div>
                <div className="mb-[10rem]">
                    <Award />
                </div>
                <div className="flex flex-wrap sm:flex-nowrap gap-[1.88rem]">
                    <TransportationLink language="zh_hant" />
                    <FacebookLink language="zh_hant" />
                </div>
            </div>
        </main>
        </>
    )
}